//axios api
import api from "@/lib/Api";

export const importProductSales = async (datas) => {
  try {
    const queryRoute = "/mannings/importProductSales";

    const reqBody = {
      datas,
    };
    const fetchRes = api.axios.post(queryRoute, reqBody);
    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const getShopSalesByDateRange = async (
  product_id,
  start_date,
  end_date
) => {
  try {
    const queryRoute = `/mannings/productSales?product_id=${product_id}&start_date=${start_date}&end_date=${end_date}`;

    const fetchRes = api.axios.get(queryRoute);
    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const importShopSales = async (datas, selectedDate) => {
  try {
    const queryRoute = "/mannings/importShopSales";

    const reqBody = {
      datas,
      selectedDate,
    };
    const fetchRes = api.axios.post(queryRoute, reqBody);
    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};
